import { Modal, Row, Col, Card, CarouselItem } from 'react-bootstrap'
import React, { Component } from 'react'
import parse, { domToReact } from 'html-react-parser';
import './summary.scss';

const cardStyle = {
    background: "#ffffff",
    border: "1px solid #ebe9f7",
    borderRadius: 14,
    boxShadow: "0 2px 10px rgba(33,48,70,0.05)",
    padding: "16px 18px",
    marginBottom: 14,
};

const numberBadge = {
    flexShrink: 0,
    width: 28,
    height: 28,
    borderRadius: 8,
    background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
    color: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
    fontWeight: 700,
    boxShadow: "0 3px 8px rgba(79,70,229,0.3)",
};

const optionLabel = {
    flexShrink: 0,
    width: 22,
    height: 22,
    borderRadius: 6,
    background: "#eef2ff",
    color: "#4f46e5",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    fontWeight: 700,
};

class SingleStudentDataModal extends Component {
    getListType(listType) {
        if (listType === "alphabets") return "A";
        if (listType === "numbers") return "1";
        if (listType === "roman") return "I";
        return "1";
    }

    answerPill(label, value, tone) {
        const tones = {
            correct: { bg: "#ecfdf5", border: "#bbf7d0", text: "#15803d" },
            wrong: { bg: "#fef2f2", border: "#fecaca", text: "#b91c1c" },
            neutral: { bg: "#f1f5f9", border: "#e2e8f0", text: "#475569" },
        };
        const t = tones[tone] || tones.neutral;
        return (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 8, background: t.bg, border: `1px solid ${t.border}`, fontSize: 13 }}>
                <span style={{ fontWeight: 600, color: "#64748b" }}>{label}</span>
                <span style={{ fontWeight: 700, color: t.text }}>{value || "—"}</span>
            </span>
        );
    }

    optionRow(letter, content) {
        return (
            <div className="d-flex align-items-center my-2">
                <span style={optionLabel}>{letter}</span>
                <div className="ml-2">{parse(content)}</div>
            </div>
        );
    }

    render() {
        let stateData = this.props.stateData.studentResults;
        return (

            <Modal {...this.props}
                size="lg" aria-labelledby="example-modal-sizes-title-lg" className="" scrollable>
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg text-center">Student Results</Modal.Title>
                </Modal.Header>
                <Modal.Body className="va-modal-body" style={{ background: "#f7f7fc" }}>
                    <style>{`.va-modal-body img{max-width:100%;max-height:200px;width:auto;height:auto;object-fit:contain;vertical-align:middle;}`}</style>
                    {
                        stateData.map((item, index) => {
                            const selectedStudent = item.studentResults?.filter((item2) => item2.mobile == this.props.stateData.mobile) || [];
                            const attempted = selectedStudent[0];
                            const questionNumber = item.slno || index + 1;
                            const attemptTone = !attempted || !attempted.attempt_answer
                                ? "neutral"
                                : (attempted.isCorrect == "2" ? "correct" : "wrong");

                            if (item.qtype == "3" || item.qtype == "9") {
                                let question1 = item.question.replace(/src="/g, 'src=\\"');
                                let question2 = question1.replace(/" \/>/g, '\\" />');
                                let question = [];
                                try {
                                    question = JSON.parse(question2);
                                }
                                catch (err) {
                                    console.log("MATRIX ERROR:", err.message);
                                }

                                return (
                                    <div style={cardStyle} key={index}>
                                        <div className="d-flex align-items-center mb-2">
                                            <span style={numberBadge}>{questionNumber}</span>
                                        </div>
                                        <Row>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                <h6 className='text-center font-weight-bold'>List-I</h6>
                                                <ol className="matrixlistoptions" type={this.getListType(item.list1type)}>
                                                    {question.map((q) => (
                                                        <li className='text-left font-weight-bold'>{parse(q.qlist1)}</li>
                                                    ))}
                                                </ol>
                                            </Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                                <h6 className='text-center font-weight-bold'>List-II</h6>
                                                <ol className="matrixlistoptions" type={this.getListType(item.list2type)}>
                                                    {question.map((q) => (
                                                        <li className='text-left font-weight-bold'>{parse(q.qlist2)}</li>
                                                    ))}
                                                </ol>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("A", item.option1)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("B", item.option2)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("C", item.option3)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("D", item.option4)}</Col>
                                        </Row>
                                        <div className="d-flex flex-wrap align-items-center mt-2" style={{ gap: 10, paddingTop: 12, borderTop: "1px solid #f1f0fa" }}>
                                            {this.answerPill("Correct Answer:", item.answer, "correct")}
                                            {this.answerPill("Attempted Answer:", attempted?.attempt_answer, attemptTone)}
                                        </div>
                                    </div>
                                )
                            }
                            else if (item.qtype == "8") {
                                return (
                                    <div style={cardStyle} key={index}>
                                        <div className="d-flex align-items-start">
                                            <span style={numberBadge}>{questionNumber}</span>
                                            <div className="ml-2 font-weight-bold" style={{ paddingTop: 3 }}>{parse(item.question)}</div>
                                        </div>
                                        <div className="d-flex flex-wrap align-items-center mt-3" style={{ gap: 10, paddingTop: 12, borderTop: "1px solid #f1f0fa" }}>
                                            {this.answerPill("Correct Answer:", item.answer, "correct")}
                                            {this.answerPill("Attempted Answer:", attempted?.attempt_answer, attemptTone)}
                                        </div>
                                    </div>
                                )
                            }
                            else if (item.qtype == "5") {
                                return (
                                    <div style={cardStyle} key={index}>
                                        <div className="d-flex align-items-start">
                                            <span style={numberBadge}>{questionNumber}</span>
                                            <div className="ml-2 font-weight-bold" style={{ paddingTop: 3 }}>{parse(item.question)}</div>
                                        </div>
                                        <Row className="mt-2">
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("A", item.option1)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("B", item.option2)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("C", item.option3)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("D", item.option4)}</Col>
                                        </Row>
                                        <div className="d-flex flex-wrap align-items-center mt-2" style={{ gap: 10, paddingTop: 12, borderTop: "1px solid #f1f0fa" }}>
                                            {this.answerPill("Correct Answer:", item.answer, "correct")}
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div style={cardStyle} key={index}>
                                        <div className="d-flex align-items-start">
                                            <span style={numberBadge}>{item.slno}</span>
                                            <div className="ml-2 font-weight-bold" style={{ paddingTop: 3 }}>{parse(item.question)}</div>
                                        </div>
                                        <Row className="mt-2">
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("A", item.option1)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("B", item.option2)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("C", item.option3)}</Col>
                                            <Col xl={6} lg={6} md={6} sm={12} className="my-1">{this.optionRow("D", item.option4)}</Col>
                                        </Row>
                                        <div className="d-flex flex-wrap align-items-center mt-2" style={{ gap: 10, paddingTop: 12, borderTop: "1px solid #f1f0fa" }}>
                                            {this.answerPill("Correct Answer:", item.answer, "correct")}
                                            {this.answerPill("Attempted Answer:", attempted?.attempt_answer, attemptTone)}
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                </Modal.Body>
            </Modal>
        )
    }
}

export default SingleStudentDataModal;
